import { render, staticRenderFns } from "./access-code.vue?vue&type=template&id=2a6f9978&scoped=true&"
import script from "./access-code.ts?vue&type=script&lang=ts&"
export * from "./access-code.ts?vue&type=script&lang=ts&"
import style0 from "./access-code.scss?vue&type=style&index=0&id=2a6f9978&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f9978",
  null
  
)

export default component.exports